import React, {CSSProperties, useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { Card, Col, Row, Spin } from 'antd';

const TreatmentDetailsCard: React.FC = () => {
  const claimDetails: any = useSelector(
    (state: RootState) => state?.claimsDetails?.claimDetails,
  );

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // creating a delay
    setTimeout(() => {
        setLoading(false);
    }, 2000);
  }, []);

  const cardHeaderStyle: CSSProperties = {
    background: '#E9ECF0',
    color: 'black',
    padding: '12px',
    textAlign: 'center',
  };
    const formatDateString = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };
  return (
    <div style={{width: '80vw', paddingLeft: '70px'}}>
        <Spin spinning = {loading}>
        <Card title = "Treatment Details" headStyle={cardHeaderStyle}>
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <label>Date of Admission</label>
            <div>{formatDateString(claimDetails.doa)}</div>
          </Col>
          <Col span={6}>
            <label>Date of Discharge</label>
            <div>{formatDateString(claimDetails.dod)}</div>
          </Col>
          <Col span={6}>
            <label>Proposed Line of treatment</label>
            <div>{claimDetails?.procedureType?.[0]?.value}</div>
          </Col>
          <Col span={6}>
            <label>Treatment</label>
            <div>{claimDetails?.procedureDescAutomation?.[0]?.maMappedProcedure}</div>
          </Col>
        </Row>
        <br/>
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <label>Diagnosis</label>
            <div>{claimDetails?.diagnosis?.[0]?.payerMasterValue}</div>
          </Col>
          <Col span={6}>
            <label>ICD10 PCS</label>
            <div>{claimDetails?.icd10pcs}</div>
          </Col>
          <Col span={6}>
            <label>ICD10</label>
            <div>{claimDetails?.icd10}</div>
          </Col>
          <Col span={6}>
            <label>Doctor Name</label>
            <div>{claimDetails?.doctorName}</div>
          </Col>
        </Row>
        <br/>
        <Row gutter={[16, 16]}>
        <Col span={6}>
            <label>Doctor Reg No</label>
            <div>{claimDetails?.docRegNo}</div>
          </Col>
          <Col span={6}>
            <label>Room Type</label>
            <div>{claimDetails?.hospitalRoomType?.[0]?.providerRoomType}</div>
          </Col>
          <Col span={6}>
            <label>Room Type</label>
            <div>{}</div>
          </Col>
          <Col span={6}>
            <label>Is Death Case</label>
            <div>{claimDetails?.isDeathCase}</div>
          </Col>
        </Row>
        <br/>
        <Row gutter={[16, 16]}>
            <Col span={8}>
            <label>Is the patient getting discharged today?</label>
            <div>{claimDetails?.isDischarge}</div>
            </Col>
            <Col span={8}>
                <label>Any other ailments</label>
                <div>{claimDetails?.ailmentAsPerUser}</div>
            </Col>
        </Row>
      </Card>
        </Spin>
    </div>
  );
};

export default TreatmentDetailsCard;
